export default __webpack_public_path__ + "static/media/avatar.ee3ecac6.png";